var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditSquareGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8821_7197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0332 2.66666H5.2332C4.1131 2.66666 3.55305 2.66666 3.12522 2.88464C2.7489 3.07639 2.44294 3.38235 2.25119 3.75867C2.0332 4.1865 2.0332 4.74655 2.0332 5.86666V11.4667C2.0332 12.5868 2.0332 13.1468 2.25119 13.5746C2.44294 13.951 2.7489 14.2569 3.12522 14.4487C3.55305 14.6667 4.1131 14.6667 5.2332 14.6667H10.8332C11.9533 14.6667 12.5134 14.6667 12.9412 14.4487C13.3175 14.2569 13.6235 13.951 13.8152 13.5746C14.0332 13.1468 14.0332 12.5868 14.0332 11.4667V8.66666M6.03319 10.6667H7.14955C7.47567 10.6667 7.63873 10.6667 7.79218 10.6298C7.92823 10.5972 8.05829 10.5433 8.17758 10.4702C8.31214 10.3877 8.42744 10.2724 8.65804 10.0418L15.0332 3.66666C15.5855 3.11437 15.5855 2.21894 15.0332 1.66666C14.4809 1.11437 13.5855 1.11437 13.0332 1.66665L6.65803 8.04182C6.42742 8.27242 6.31212 8.38772 6.22967 8.52228C6.15656 8.64157 6.10269 8.77163 6.07003 8.90768C6.03319 9.06113 6.03319 9.22419 6.03319 9.55031V10.6667Z",
    stroke: "#636874",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8821_7197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.699219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquareGrey);
export default __webpack_public_path__ + "static/media/edit-square-grey.1a63f54c1344a2ac17140d9bac704544.svg";
export { ForwardRef as ReactComponent };